<template lang="pug">
    .page
        a-modal(v-model="addVisible" 
            title="创建分组" 
            @ok="handleCreateOk" 
            ok-text="创建"
            cancel-text="取消")
            a-input(v-model="newGroupName" placeholder="请输入分组名称")

        a-drawer(:visible="editVisible" 
            title="编辑分组" 
            width="500"
            @close="editVisible=false"
        )
            a-checkbox-group(v-model="selectedUsers" :options="users.map(i => ({label: i.name, value: i._id}))")
            a-button(type="primary" style="margin-top:10px" @click="submitEdit") 更新用户

            a-divider
            a-input(v-model="newGroupName", placeholder="请输入新名称")
            a-button(type="primary" style="margin-top:10px" @click="submitRename") 更新名称

        .ctl-bar
            a-button(type="primary" 
                @click="handleCreate" 
                style=" margin-right:20px") 
                a-icon(type="plus")
                span 创建

            a-button(type="primary" 
                style=" margin-right:20px" 
                @click="getData") 
                a-icon(type="redo")
                span 刷新

        a-table(:columns="columns", 
            size="small"
            :dataSource="items"
            :pagination="false"
            rowKey="_id")
            template(slot="action" slot-scope="record")
                a-popconfirm(title="确认删除该分组吗？" 
                    ok-text="确认" 
                    cancel-text="取消" 
                    @confirm="submitDelete(record._id)")
                    a 
                        a-icon(type="delete")
                a-divider(type="vertical")
                a(@click="handleEdit(record)") 
                    a-icon(type="edit")

            template(slot="expandedRowRender" slot-scope="record")
                .user-list
                    strong 用户列表:
                    div(v-for="userId in record.users" :key="userId" style="margin-right:10px")
                        span {{ users.find(u => u._id === userId)?.name || '未知用户' }}

</template>

<script>
export default {
    data() {
        return {
            addVisible: false,
            newGroupName: '',

            columns: [
                {
                    title: '名称',
                    dataIndex: 'name',
                    sorter: (a, b) => a.name.localeCompare(b.name),
                },
                {
                    title: '文件数量',
                    dataIndex: 'fileCount',
                    sorter: (a, b) => a.fileCount - b.fileCount,
                },
                {
                    title: '用户数量',
                    dataIndex: 'userCount',
                    sorter: (a, b) => a.userCount - b.userCount,    
                },
                {
                    title: 'createdAt',
                    dataIndex: 'createdAt',
                    sorter: (a, b) => new Date(a.createdAt) - new Date(b.createdAt),
                },
                {
                    title: '操作',
                    scopedSlots: { customRender: 'action' },
                }
            ],
            items: [],
            users: [],
            selectedUsers: [],
            editVisible: false,
            editingGroupId: '',
        };
    },
    mounted() {
        this.getUsers();
        this.getData();
    },
    methods: {
        handleEdit(record) {
            this.editVisible = true;
            this.newGroupName = record.name;
            this.selectedUsers = record.users;
            this.editingGroupId = record._id;
        },
        submitEdit() {
            this.$api.request('POST', `group/update/users`, { users: this.selectedUsers, _id: this.editingGroupId }, 'fs')
            .then(res => {
                this.$message.success('更新用户成功');
                this.getData();
            });
        },
        submitRename() {
            this.$api.request('POST', `group/rename/${this.editingGroupId}`, { newName: this.newGroupName }, 'fs')
            .then(res => {
                this.$message.success('重命名成功');
                this.getData();
            });
        },
        handleCreate() {
            this.addVisible = true;
        },
        handleCreateOk() {
            this.$api.request('POST', 'group/create', { name: this.newGroupName }, 'fs')
            .then(res => {
                this.$message.success('创建成功');
                this.newGroupName = '';
                this.addVisible = false;
                this.getData();
            });
        },
        getData() {
            this.$api.request('GET', 'groups', {}, 'fs')
            .then(res => {
                this.items = res.data.map(item => ({
                    ...item,
                    createdAt: new Date(item.createdAt).toLocaleString(),
                }));
            })
        },
        getUsers() {
            this.$api.request("GET", 'users')
            .then(res => {
                this.users = res.data;
            });
        },
        submitDelete(id) {
            this.$api.request('DELETE', `group/${id}`, {}, 'fs')
            .then(res => {
                this.$message.success('删除成功');
                this.getData();
            })
        }
    },
};
</script>

<style lang="less" scoped>
.user-list {
    display: flex;
    flex-wrap: wrap;
    margin-top: 10px;
    div {
        background: #f0f0f0;
        padding: 5px 10px;
        border-radius: 4px;
        margin-bottom: 5px;
    }
}
</style>
